import axios from "axios";
import Swal from "sweetalert2";

const token = localStorage.getItem("token");
if (token) axios.defaults.headers.post["Authorization"] = `Bearer ${token}`;

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";

axios.interceptors.response.use(null, (error) => {
    const expectedErrors = error.response && error.response.status >= 400 && error.response.status < 500;
    if (!expectedErrors) {
        Swal.fire("Oops...", "! Your Internet Connection Is Unstable", "error");
    }

    return Promise.reject(error);
});

const methods = {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
};

export default methods;
